export var DataCatalogPolicyKind;
(function (DataCatalogPolicyKind) {
    DataCatalogPolicyKind["DATA_CATALOG_POLICY_KIND_ROW_FILTER"] = "ROW_FILTER";
    DataCatalogPolicyKind["DATA_CATALOG_POLICY_KIND_MASKING"] = "MASKING";
})(DataCatalogPolicyKind || (DataCatalogPolicyKind = {}));
